import { useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import OTPInput from "react-otp-input";
import "../../src/Loogin.css";
import "../App.css";
import { verifyOtp } from '../services/apiService';
import CountdownTimer from './CountDownTimer';
import SuccessPage from '../pages/ResultPage';


const OtpForm = ({ phoneNumber, otpSend, id, displayLoader }: any) => {

    const navigate = useNavigate();

    const [otp, setOtp] = useState('');
    const [otpError, setOtpError] = useState('');
    const [showSuccess, setShowSuccess] = useState<boolean>(false);
    const timerRef: React.Ref<any> = useRef(null);

    const resendOTP = async () => {
        // displayLoader(true);
        try {
            const response = await otpSend();
            if (response.error?.code === 'ERR026') {
                setOtpError("You have exceeded your limit to receive OTP. Try again later.");
            }
    
            if (timerRef.current) {
                timerRef.current.resetTimer();
            }
        } catch (error) {
            // Handle errors if necessary
            console.error(error);
        } finally {
            displayLoader(false);
        }
    };
    


    const handleOTPSubmit = () => {

        // Verify OTP and log the user in.
        var data = {
            "phoneNumber": phoneNumber,
            "customerId": id,
            "otp": otp
        }
        verifyOtp(data).then(async (response) => {
            if (response.success) {
                setOtpError('');
                setShowSuccess(true);
                // navigate('/result');
            }
            else if (response?.error) {
                if (response.error.code != undefined) {
                    if (response['error']['code'] == 'ERR017') {
                        setOtpError('Invalid OTP');
                    } else if (response['error']['code'] == 'ERR016') {
                        setOtpError('OTP Expired');
                    } else if (response.error?.code == 'ERR033') {
                        setOtpError('You have Exceeded your limit of incorrect attempts.');
                    }
                }
            }
        });
    }

    return (
        <>
            {!showSuccess ? (
                <div style={{ marginTop: '4rem' }}>
                    <p className='otpLabel'>An OTP has been sent to your mobile number</p>
                    <div style={{ color: 'grey' }}>Enter your OTP here</div>

                    <div className="verifyDiv">

                        <div className="otpElements">

                            <div className="otp">
                                <OTPInput
                                    // name='otp'
                                    // shouldAutoFocus
                                    onChange={setOtp}
                                    value={otp}
                                    inputStyle="inputStyle"
                                    numInputs={6}
                                    inputType="number"
                                    renderSeparator={<span>&nbsp;&nbsp;&nbsp;</span>}
                                    renderInput={(props) => <input {...props} />}
                                />
                            </div>

                            <p className="errorText">{otpError || <span>&nbsp;&nbsp;</span>}</p>

                            {/* <h4 className="errorText">{userError.otp}</h4> */}

                            <div className="timer--div">
                                <div className="otppage">
                                    <p className="resend">OTP valid for </p>
                                    <div className="timer">
                                        <CountdownTimer ref={timerRef} />
                                    </div>
                                </div>
                                <div className="resendtwo" onClick={resendOTP}> Resend OTP </div>
                            </div>
                        </div>
                    </div>

                    <button onClick={handleOTPSubmit}>Submit OTP</button>

                </div>

            ) : (
                <SuccessPage/>
        )}
        </>
    )
};

export default OtpForm;